import { apiFetch } from './client';

export interface IvrEdgeRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  from_node_id: string;
  to_node_id: string | null;
  branch_key: string;
  label: string | null;
  sort_order: number;
  created_at: string;
}

export interface CreateEdgeBody {
  branch_key: string;
  to_node_id: string;
  label?: string;
  sort_order?: number;
}

/**
 * Append `?customer_id=<id>` when supplied. Used by the tree-scoped
 * edge route so a ref-form treeId like `IVT-7` resolves to the right
 * customer's tree (bugfix 2026-05-17, follows the same shape as
 * ivrTrees.ts).
 */
function withCustomer(path: string, customerId?: string | null): string {
  if (!customerId) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}customer_id=${encodeURIComponent(customerId)}`;
}

export const ivrEdges = {
  listForNode: (fromId: string) =>
    apiFetch<{ rows: IvrEdgeRow[] }>(`/api/ivr/nodes/${fromId}/edges`),
  listForTree: (treeId: string, opts: { customerId?: string | null } = {}) =>
    apiFetch<{ rows: IvrEdgeRow[] }>(
      withCustomer(`/api/ivr/trees/${treeId}/edges`, opts.customerId),
    ),
  create: (fromId: string, body: CreateEdgeBody) =>
    apiFetch<IvrEdgeRow>(`/api/ivr/nodes/${fromId}/edges`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  remove: (id: string) =>
    apiFetch<void>(`/api/ivr/edges/${id}`, { method: 'DELETE' }),
};
